<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Concentração de contratos ativos</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Relatórios Concentração de
                                Contratos Ativos</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-report-card">
                            <div class="card-body">
                                <div class="row gp-report-filters">
                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <v-autocomplete v-model="GarantidoraSelected" :items="Garantidoras" item-title="garNomeEmpresa" item-value="garId"
                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhum registro encontrado" @update:model-value="BuscaImobiliarias()" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0 || User.tpeid == 1">
                                        <div class="form-group">
                                            <label>Imobiliaria</label>
                                            <v-autocomplete v-model="ImobiliariaSelected" :items="Imobiliarias" item-title="imoNomeEmpresa" item-value="imoId"
                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhum registro encontrado" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select v-model="TipoSelected" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="(optionTipo, index) in Tipos" :key="index"
                                                    :value="optionTipo.valor">{{ optionTipo.texto }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Data Inicial</label>
                                            <input v-model="DataIncial" type="date" class="form-control"
                                                placeholder="Data Inicial" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Data Final</label>
                                            <input v-model="DataFinal" type="date" class="form-control"
                                                placeholder="Data Final" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <button type="button" class="btn btn-info"
                                            style="color:#ffffff;margin-top: 35px;" @click="Pesquisar()">
                                            Pesquisar
                                        </button>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <a href="#" @click="EditCancel()" class="btn btn-link"
                                            style="margin-top: 35px;">Cancelar</a>
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px;padding-bottom: 20px;">
                                    <hr>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center">
                                            <h4 class="card-title">Resultado</h4>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" md="6" style="text-align: right;padding-right: 15px;">
                                                <button @click="exportCSV" class="btn btn-warning">Exportar CSV</button>
                                            </v-col>
                                        </v-row>
                                        <adm-data-table :headers="headers" :items="ListResult" v-model="itemsSelected" :show-filters="false" :show-export="true" file-name="concentracao-contratos-ativos"
                                            alternating theme-color="#364f66" table-class-name="customize-table"
                                            header-text-direction="center" body-text-direction="center"
                                            rows-per-page-message="Linhas por pagina">
                                            <template #item-pdiDataVigenciaIni="item">
                                                <span> {{ item.pdiDataVigenciaIni !== null ?
                                                    formattedDate(item.pdiDataVigenciaIni) : null }}</span>
                                            </template>
                                            <template #item-pdiDataVigenciaFim="item">
                                                <span> {{ item.pdiDataVigenciaFim !== null ?
                                                    formattedDate(item.pdiDataVigenciaFim) : null }}</span>
                                            </template>
                                            <template #item-pedValorTotalPedido="item">
                                                <span> {{ item.pedValorTotalPedido !== null ?
                                                    formatarValor(item.pedValorTotalPedido) : null }}</span>
                                            </template>
                                        </adm-data-table>
                                    </div>
                                    <div class="col-md-6">
                                        <div v-if="ListResult && ListResult.length > 0">
                                            <PieChart :datacollection="datacollection" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import EasyDataTable from 'vue3-easy-data-table'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import moment from 'moment'
import PieChart from '../../components/PagePieChart.vue'

export default {
  name: 'RelatorioConcentracaoContratosAtivosView',
  components: {
    EasyDataTable,
    moment,
    PieChart
  },
  data: () => ({
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0
    },
    editor: DecoupledEditor,
    GarantidorasGeral: [],
    Garantidoras: [],
    GarantidoraSelected: null,
    ImobiliariasGeral: [],
    Imobiliarias: [],
    ImobiliariaSelected: null,
    ClientesGeral: [],
    Clientes: [],
    ClienteSelected: null,
    DataIncial: '',
    DataFinal: '',
    searchValue: '',
    itemsSelected: [],
    ListResult: [],
    ListPedidosGeral: [],
    ListPedidosGeralFiltro: [],
    ListaPedidoItem: [],
    headers: [],
    TipoSelected: null,
    Tipos: [{ texto: 'Estado', valor: 'Estado' }, { texto: 'Cidade', valor: 'Cidade' }, { texto: 'Tipo Imóvel', valor: 'Tipo Imóvel' }],
    datacollection: {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40'
        ]
      }]
    }
  }),
  methods: {
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    EditGrid (item) {

    },
    EditCancel () {
      this.$router.go(0)
    },
    GarantidoraEdit (Value) {
      this.Garantidoras = this.GarantidorasGeral.filter(x => x.garId == Value).sort((a, b) =>
        a.garNomeEmpresa.localeCompare(
          b.garNomeEmpresa,
          'pt',
          { sensitivity: 'base' }
        )
      )
      this.GarantidoraSelected = Value
      this.BuscaImobiliarias()
    },
    BuscaImobiliarias () {
      if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
        this.ImobiliariaSelected = null
        this.ImobiliariasGeral = []
        this.Imobiliarias = []
        axios.get('/Telas/RelatorioConcentracaoContratos/GetByGarIdParIdImobiliarias/' + this.GarantidoraSelected + '/0')
          .then(response => {
            if (response.data.length > 0) {
              this.ImobiliariasGeral = response.data.sort((a, b) =>
                a.imoNomeEmpresa.localeCompare(
                  b.imoNomeEmpresa,
                  'pt',
                  { sensitivity: 'base' }
                )
              )
              this.Imobiliarias = this.ImobiliariasGeral
            }
          })
      } else {
        this.ImobiliariaSelected = null
        this.ImobiliariasGeral = []
        this.Imobiliarias = []
        this.ClienteSelected = null
        this.ClientesGeral = []
        this.Clientes = []
      }
    },
    montaGrid () {
      this.headers = []
      if (this.TipoSelected === 'Estado') {
        this.headers.push({ text: 'Estado', value: 'valor', sortable: true })
      }
      if (this.TipoSelected === 'Cidade') {
        this.headers.push({ text: 'Cidade', value: 'valor', sortable: true })
      }
      if (this.TipoSelected === 'Tipo Imóvel') {
        this.headers.push({ text: 'Tipo Imóvel', value: 'valor', sortable: true })
      }
      this.headers.push({ text: 'Quantidade', value: 'quantidade', sortable: true })
    },
    updateChartData (newLabels, newValues) {
      this.datacollection = {
        labels: newLabels,
        datasets: [{
          data: newValues,
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#4BC0C0',
            '#9966FF',
            '#FF9F40'
          ]
        }]
      }
    },
    montarGrafico () {
      const newLabels = this.ListResult.map(item => item.valor)
      const newValues = this.ListResult.map(item => item.quantidade)
      this.updateChartData(newLabels, newValues)
      // console.log('this.datacollection')
      // console.log(this.datacollection)
    },
    async Pesquisar () {
      // Validação: DataFinal não pode ser menor que DataIncial
      if (moment(this.DataFinal).isBefore(moment(this.DataIncial))) {
        this.$mensagemAviso('Data Final não pode ser menor que Data Inicial!')
        return
      }
      if (this.TipoSelected == null || this.TipoSelected == '') {
        this.$mensagemAviso('Selecione o Tipo de Concentração!')
        return
      }

      // Define os parâmetros para a consulta
      const _garId = this.GarantidoraSelected || 0
      const _tpeid = this.ImobiliariaSelected ? 3 : 0
      const _pesid = this.ImobiliariaSelected || 0

      try {
        // Consulta os pedidos
        const response = await axios.get(
                    `/Telas/RelatorioConcentracaoContratos/GetAllValorTotal/${_garId}/${_tpeid}/${_pesid}`
        )
        // Filtra para pegar somente os pedidos com situação "Vigente"
        this.ListPedidosGeral = response.data.filter(
          (x) => x.pedSituacaoPedido === 'Vigente'
        )

        // Mapeia os pedidos para incluir informações adicionais
        this.ListPedidosGeralFiltro = this.ListPedidosGeral.map((pedido) => {
          // Busca a garantidora correspondente pelo garId
          const garantidora = this.GarantidorasGeral.find((g) => g.garId === pedido.garId)
          // Busca a imobiliária correspondente pelo imobId
          const imobiliaria = this.ImobiliariasGeral.find((i) => i.imoId === pedido.imobId)

          return {
            ...pedido,
            NomeGarantidora: garantidora ? garantidora.garNomeEmpresa : 'Não encontrada',
            DocumentoImobiliaria: imobiliaria ? imobiliaria.imoDocumento : 'Não encontrada',
            pdcEstado: null, // Inicializa como null
            pdcCidade: null,
            pdcTipo: null
          }
        })

        // Para cada pedido, busca os itens e atualiza os campos (usa Promise.all para aguardar todas as chamadas)
        await Promise.all(
          this.ListPedidosGeralFiltro.map(async (element) => {
            try {
              const responseItem = await axios.get(
                '/Telas/RelatorioConcentracaoContratos/GetAllByPedIdEndereco/' + element.pedId
              )
              if (responseItem.data.length > 0) {
                const primeiroItem = responseItem.data[0] // Usa apenas o primeiro item
                element.pdcEstado = primeiroItem.pdcEstado
                element.pdcCidade = primeiroItem.pdcCidade
                element.pdcTipo = primeiroItem.pdcTipo + (primeiroItem.pdcResidencialTipo != '' ? ' - ' + primeiroItem.pdcResidencialTipo : '')
              }
            } catch (error) {
              console.error('Erro ao buscar itens para o pedido ' + element.pedId, error)
            }
          })
        )

        // Inicia o filtro com a lista completa
        let filtered = [...this.ListPedidosGeralFiltro]
        console.log(filtered)

        // Aplica o filtro por data (usando pedDataPedido) se ambos os campos estiverem preenchidos
        if (this.DataFinal !== '' && this.DataIncial !== '') {
          // Converte os filtros para objetos Date
          const dataInicio = new Date(this.DataIncial)
          const dataFinal = new Date(this.DataFinal)
          // Ajusta o final do dia para incluir todo o dia
          dataFinal.setHours(23, 59, 59, 999)

          filtered = filtered.filter((x) => {
            // Se a data do pedido estiver ausente, ignora o registro
            if (!x.pedDataPedido) {
              console.error('Data inválida para o registro:', x)
              return false
            }
            const dataRegistro = new Date(x.pedDataPedido)
            if (isNaN(dataRegistro.getTime())) {
              console.error('Data inválida para o registro:', x.pedDataPedido)
              return false
            }
            return dataRegistro >= dataInicio && dataRegistro <= dataFinal
          })
        }

        // Após todos os filtros terem sido aplicados na variável "filtered"
        if (this.TipoSelected === 'Estado') {
          // Agrupar por pdcEstado
          const agrupado = filtered.reduce((acc, item) => {
            // Usa o valor do estado ou um rótulo padrão se não existir
            const key = item.pdcEstado || 'Sem Estado'
            if (!acc[key]) {
              acc[key] = {
                valor: key,
                quantidade: 0
              }
            }
            acc[key].quantidade++
            return acc
          }, {})
          this.ListResult = Object.values(agrupado)
        } else if (this.TipoSelected === 'Cidade') {
          // Agrupar por pdcCidade
          const agrupado = filtered.reduce((acc, item) => {
            const key = item.pdcCidade || 'Sem Cidade'
            if (!acc[key]) {
              acc[key] = {
                valor: key,
                quantidade: 0
              }
            }
            acc[key].quantidade++
            return acc
          }, {})
          this.ListResult = Object.values(agrupado)
        } else if (this.TipoSelected === 'Tipo Imóvel') {
          // Agrupar por pdcTipo
          const agrupado = filtered.reduce((acc, item) => {
            const key = item.pdcTipo || 'Sem Tipo'
            if (!acc[key]) {
              acc[key] = {
                valor: key,
                quantidade: 0
              }
            }
            acc[key].quantidade++
            return acc
          }, {})
          this.ListResult = Object.values(agrupado)
        } else {
          // Se nenhum agrupamento foi selecionado, mantém a ordenação padrão
          this.ListResult = filtered.sort((a, b) => {
            return (
              a.valor.localeCompare(b.valor)
            )
          })
        }

        this.montaGrid()
        this.montarGrafico()

        console.log('this.ListResult1', this.ListResult)
      } catch (error) {
        console.error(error)
      }
    },
    exportCSV () {
      if (this.ListResult.length === 0) {
        alert('Não há dados para exportar.')
        return
      }

      let _Garantidora = 'Todas'
      let _Imobliaria = 'Todas'

      if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
        _Garantidora = this.GarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa
      }

      if (this.ImobiliariaSelected != '' && this.ImobiliariaSelected != null) {
        _Imobliaria = this.ImobiliariasGeral.filter(x => x.imoId == this.ImobiliariaSelected)[0].imoNomeEmpresa
      }
      // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
      const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Imobiliária: ${_Imobliaria}\n` +
                `Data Inicial: ${this.DataIncial}\n` +
                `Data Final: ${this.DataFinal}\n` +
                `Tipo de Concentração: ${this.TipoSelected}\n\n`

      // Cria o cabeçalho do CSV (os nomes das colunas)
      const csvHeader = this.headers.map(h => h.text).join(';') + '\n'

      // Cria as linhas com os dados do grid
      const csvRows = this.ListResult.map(item =>
        [
          item.valor,
          item.quantidade
        ].join(';')
      ).join('\n')

      // Concatena os filtros, o cabeçalho e as linhas de dados
      const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + filtroCSV + csvHeader + csvRows

      // Cria o link de download
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'RelatorioConcentracaoContratosAtivos.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async Get () {
      await axios.get('/Telas/RelatorioConcentracaoContratos/GetDados')
        .then(response => {
          this.GarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
            a.garNomeEmpresa.localeCompare(
              b.garNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )
          this.User.tpeid = response.data.tpeId
          this.User.garid = response.data.garId
          this.User.pesid = response.data.pesId

          this.ImobiliariasGeral = response.data.imobiliarias.sort((a, b) =>
            a.imoNomeEmpresa.localeCompare(
              b.imoNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )

          if (this.User.garid == 0) {
            this.EditView = false
            this.Garantidoras = this.GarantidorasGeral.sort((a, b) =>
              a.garNomeEmpresa.localeCompare(
                b.garNomeEmpresa,
                'pt',
                { sensitivity: 'base' }
              )
            )
          } else {
            this.GarantidoraEdit(this.User.garid)
          }
          this.montaGrid()
        })
    }
  },
  created () {
    this.Get()
  },
  watch: {
    ListResult (newVal) {
      const newLabels = newVal.map(item => item.valor)
      const newValues = newVal.map(item => item.quantidade)
      this.updateChartData(newLabels, newValues)
    }
  }
}
</script>

<style></style>
